import $ from "jquery";
let scope = getScopeUrlParam();
let hsaId = getHsaIdUrlParam();
let scopeQuery = "";
let hsaIdQuery = ""
if (scope)
    scopeQuery = "&s=" + scope;
if (hsaId) hsaIdQuery = "&hsaids=" + hsaId;

const lang = document.documentElement.getAttribute('lang');

function handleKeyDown(event) {
    let resultContainer = $("#autocomplete-result");
    let searchButton = $("#search-button");
    let searchField = $("#search");
    switch (event.key) {
        case 'ArrowDown':
        case 'Down':
            if (event.target) {
                let linkItems = Array.from(document.querySelectorAll('.autocomplete__link'));
                let nextIndex = linkItems.indexOf(event.target) + 1;
                linkItems[nextIndex === linkItems.length ? 0 : nextIndex].focus();
            }
            break;
        case 'ArrowUp':
        case 'Up':
            {
                let linkItems1 = Array.from(document.querySelectorAll('.autocomplete__link'));
                let nextIndex1 = linkItems1.indexOf(event.target) - 1;
                linkItems1[nextIndex1 === -1 ? linkItems1.length - 1 : nextIndex1].focus();
                break;
            }
        case 'Tab':
            resultContainer.addClass("hidden");
            searchButton.focus();
            break;
        case 'Escape':
        case 'Esc':
                resultContainer.addClass("hidden");
                searchField.focus();
            break;
        case 'ArrowRight':
        case 'Right':
            {
                let menus = Array.from(document.querySelectorAll('#searchquery-list, #www-list, #dokument-list, #person-list'))
                let currentMenu = menus.find(function (x) { return $(x).find(event.target).length > 0 });
                let nextIndex2 = menus.indexOf(currentMenu) + 1;

                let nextMenu = menus[nextIndex2 === menus.length ? 0 : nextIndex2];
                nextMenu.querySelector('.autocomplete__link').focus();
                break;
            }
        case 'ArrowLeft':
        case 'Left':
            {
                let menus1 = Array.from(document.querySelectorAll('#searchquery-list, #www-list, #dokument-list, #person-list'))
                let currentMenu1 = menus1.find(function (x) { return $(x).find(event.target).length > 0 });
                let prevIndex = menus1.indexOf(currentMenu1) - 1;

                let prevMenu = menus1[prevIndex === menus1.length ? 0 : prevIndex];
                prevMenu.querySelector('.autocomplete__link').focus();
                break;
            }
    }
}

function getUrlParameter(sParam) {
    let sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0].toLowerCase() === sParam.toLowerCase()) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

function getScopeUrlParam() {
    let scope = getUrlParameter("scope");
    if (!scope)
        scope = getUrlParameter("s");
    return scope;
}
function getHsaIdUrlParam() {
    let hsaId = getUrlParameter("hsaids");
    if (!hsaId)
        hsaId = getUrlParameter("HsaIdCollection");

    if (!hsaId)
        hsaId = "";
    return hsaId;
}
function addSearchQueries(queries, container) {
    let form = $("#search-form");
    let url = form.attr("action") + "?qc=true&q=";

    let header = $("<section>", { html: "<h2 class='autocomplete-header'>" + (lang === "en" ? "Search suggestions" : "S&ouml;kordsf&ouml;rslag") + "</h2>" }).appendTo(container);
    header.addClass("autocomplete-resultheader");
    let ulList = $(header).append("<ul id='searchquery-list' ></ul>").find("#searchquery-list");

    if (queries.length < 1) return;
    $.each(queries, function (i) {
        let format = (queries[i].format != null ? "file " + queries[i].format.substring(queries[i].format.lastIndexOf(".") + 1) : "file");
        let li = $("<li/>").appendTo(ulList);
        li.addClass(format);
        let aaa = $("<a >", {
            html: queries[i].label_hl,
            href: url + queries[i].label + scopeQuery + hsaIdQuery
        }).appendTo(li);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom sökordsförslag");
        if (queries[i].revisiondate != null || queries[i].scopelabel != null) {
            $("<p>", {
                html: (queries[i].revisiondate != null ? queries[i].revisiondate : "") + (queries[i].scopelabel != null ? " - " + queries[i].scopelabel : "")
            }).appendTo(li);
        }
    });
}

function addWww(queries, container) {
    let form = $("#search-form");
    let header = $("<section>", { html: "<h2 class='autocomplete-header'>" + (lang === "en" ? "Pages" : "Webb") + "</h2>" }).appendTo(container);
    header.addClass("autocomplete-resultheader");
    let ulList = $(header).append("<ul id='www-list' ></ul>").find("#www-list");
    let url = form.attr("action") + "?qc=true&q=";
    if (queries.length < 1) return;
    $.each(queries, function (i) {
        if (i > 1)
            return;

        let li = $("<li/>").appendTo(ulList);
        li.addClass("image web");
        /*    var h3 = $("<h3>").appendTo(li);*/
        let aaa = $("<a>", {
            html: queries[i].label_hl ?? queries[i].label,            
            href: url + queries[i].label + scopeQuery + hsaIdQuery
        }).appendTo(li);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom Webb");
        if (queries[i].revisiondate != null || queries[i].scopelabel != null) {
            $("<p>", {
                html: (queries[i].revisiondate != null ? queries[i].revisiondate : "") + (queries[i].scopelabel != null ? " - " + queries[i].scopelabel : "")
            }).appendTo(li);
        }
    });
}

function addDokument(queries, container) {
    let header = $("<section>", { html: "<h2 class='autocomplete-header'>" + (lang === "en" ? "Documents" : "Dokument") + "</h2>" }).appendTo(container);
    header.addClass("autocomplete-resultheader");
    let ulList = $(header).append("<ul id='dokument-list' ></ul>").find("#dokument-list");

    if (queries.length < 1) return;
    $.each(queries, function (i) {
        if (i > 1)
            return;
        let format = (queries[i].format != null ? "file " + queries[i].format.substring(queries[i].format.lastIndexOf(".") + 1) : "file");
        let li = $("<li/>").appendTo(ulList);
        li.addClass(format);
        let aaa = $("<a>", {
            html: queries[i].label_hl ?? queries[i].label,
            href:  queries[i].url
        }).appendTo(li);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom dokument");
        if (queries[i].revisiondate != null || queries[i].scopelabel != null) {
            $("<p>", {
                html: (queries[i].revisiondate != null ? queries[i].revisiondate : "") + (queries[i].scopelabel != null ? " - " + queries[i].scopelabel : "")
            }).appendTo(li);
        }
    });
}

function addVerksamhet(queries, container, isIntranet) {
    let header = $("<section>", { html: "<h2 class='autocomplete-header'>" + (lang === "en" ? "Organizations" : "Verksamhet") + "</h2>" }).appendTo(container);
    header.addClass("autocomplete-resultheader");
    let ulList = $(header).append("<ul id='verksamhet-list' ></ul>").find("#verksamhet-list");

    if (queries.length < 1) return;
    $.each(queries, function (i) {
        if (i > 1)
            return;
        let li = $("<li/>").appendTo(ulList);
        li.addClass("image business");
        let href = '';
        if (queries[i].hsaIdentity !== undefined) {
             if (isIntranet == true) {
                href = '/sok-verksamheter?hsaIdentity=' + queries[i].hsaIdentity;
            }
            else {
                href = '/verksamheter?hsaIdentity=' + queries[i].hsaIdentity;
            }
        } else {
            href = queries[i].url;
        }

        let aaa = $("<a>", {
            html: queries[i].label_hl ?? queries[i].label,
            href: href
        }).appendTo(li);
        aaa.attr('aria-label', queries[i].label + " inom verksamheter");
        aaa.addClass("autocomplete__link");
        if (queries[i].phonenumber != null) {
            $("<p>", {
                html: "<a href='tel:" + queries[i].phonenumber + "' target='_top'>" + queries[i].phonenumber + "</a>"
            }).appendTo(li);
        }

    });
}

function addPerson(queries, container, isIntranet) {
    let header = $("<section>", { html: "<h2 class='autocomplete-header'>" + (lang === "en" ? "Persons" : "Personer") + "</h2>" }).appendTo(container);
    header.addClass("autocomplete-resultheader");
    let ulList = $(header).append("<ul id='person-list' ></ul>").find("#person-list");

    if (queries.length < 1) return;
    $.each(queries, function (i) {
        if (i > 1)
            return;
        let li = $("<li/>").appendTo(ulList);

        li.addClass("image person");

        let href = '';
        if (queries[i].vgrid !== undefined) {
             if (isIntranet == true) {
                href = '/sok-person?vgrid=' + queries[i].vgrid;
            }
            else {
                href = '/person?vgrid=' + queries[i].vgrid;
            }
        } else {
            href = queries[i].url;
        }

        let aaa = $("<a>", {
            html: queries[i].label_hl ?? queries[i].label,
            href: href,
        }).appendTo(li);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom person");
        if (queries[i].email != null) {
            $("<p>", {
                html: "<a  href='mailto:" + queries[i].email + "' target='_top'>" + queries[i].email + "</a>"
            }).appendTo(li);
        }
    });
}
function addCloseResultContainerListener(searchField, searchButton, resultContainer) {
    closeResultContainerMousedown(resultContainer);
    closeResultContainerFocusin(searchField, searchButton, resultContainer);
    closeResultContainerEsc(resultContainer);
}

function closeResultContainerMousedown(resultContainer) {
    $("body").mousedown(function (e) {
        if (resultContainer.length > 0) {
            if (e.target.offsetParent == null || e.target.offsetParent.id !== resultContainer[0].id) {
                resultContainer.addClass("hidden");
            }
        }
    });
}

function closeResultContainerFocusin(searchField, searchButton, resultContainer) {
    $("body").focusin(function (e) {
        if (resultContainer.length > 0) {
            let focused = document.activeElement.id;
            if (focused !== searchField[0].id && focused !== searchButton[0].id && e.target.offsetParent && e.target.offsetParent.id !== resultContainer[0].id) {
                resultContainer.addClass("hidden");
            }
        }
    });
}

function closeResultContainerEsc(resultContainer) {
    $(document).on("keyup", function (evt) {
        if (evt.keyCode == escape) {
            resultContainer.addClass("hidden");
        }
    });
}

export { handleKeyDown, getScopeUrlParam, getHsaIdUrlParam, addSearchQueries, addWww, addDokument, addVerksamhet, addPerson, addCloseResultContainerListener };
